import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MathService } from '@tekman/shared/component/generic';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'concealable-panel',
  templateUrl: './concealable-panel.component.html',
  styleUrls: ['./concealable-panel.component.scss'],
})
export class ConcealablePanelComponent {
  @Input() title: string;
  @Input() isTry: boolean;
  @Input() set content(value: string) {
    if (!value) {
      this.resetComponent();
    } else {
      this.setShowButtonToogle(value);
      this.contentHasVideo = value.includes('<iframe');
      if (this.contentHasVideo) {
        this.seeContent = !this.seeContent;
        this.contentIsShown = !this.contentIsShown;
      }
      this.contentSanitize = this.sanitizer.bypassSecurityTrustHtml(this.mathService.parseMath(value));
      this.mathService.renderMath();
    }
  }

  @Input() categoryId: string;
  @Input() typePanel: string;
  @Output() openedToggle: EventEmitter<{
    isOpened: boolean;
    typePanel: string;
    clickedFrom: 'icon' | 'panel';
  }> = new EventEmitter<{
    isOpened: boolean;
    typePanel: string;
    clickedFrom: 'icon' | 'panel';
  }>();
  contentSanitize: SafeHtml;
  isShown = false;
  seeContent = false;
  contentIsShown = false;
  showString = 'f.concealable-panel.show-more';
  showDraggable = false;
  resizing = false;
  contentHasVideo = false;
  showButtonToogle: boolean;

  constructor(
    private sanitizer: DomSanitizer,
    private readonly mathService: MathService
  ) {}

  onDragDropped(ev: Event) {
    const initialTranslate = ev['source'].element.nativeElement.style.transform;
    if (ev['source'].element.nativeElement.style.transform.includes('-')) {
      const y = ev['source'].element.nativeElement.style.transform.match(/-?\d+/g)[2];
      const stringY = `${y.toString() + 'px'}`;
      const finalTranslate = initialTranslate.replace(stringY, '0px');
      return (ev['source'].element.nativeElement.style.transform = finalTranslate);
    }
  }

  showAll() {
    this.seeContent = !this.seeContent;
    this.contentIsShown = !this.contentIsShown;
    this.showString = this.contentIsShown ? marker('f.concealable-panel.show-less') : marker('f.concealable-panel.show-more');
  }

  toggleAll() {
    this.isShown = !this.isShown;
    this.seeContent = !this.seeContent;
    this.openedToggle.emit({ isOpened: this.isShown, typePanel: this.typePanel, clickedFrom: 'icon' });
  }

  showDraggableContent() {
    this.showDraggable = !this.showDraggable;
    this.isShown = false;
    this.seeContent = false;
    this.contentIsShown = false;
    this.showString = this.contentHasVideo ? '' : 'f.concealable-panel.show-more';
    this.openedToggle.emit({ isOpened: this.showDraggable, typePanel: this.typePanel, clickedFrom: 'panel' });
  }

  isResizing() {
    this.resizing = true;
  }

  private setShowButtonToogle(content: string): void {
    const lineBreaks = (content.match(/\n/g) || []).length;
    const notHasLineBreak = lineBreaks === 0 && content.trim() !== '';
    this.showButtonToogle = content.length > 300 || lineBreaks + (notHasLineBreak ? 1 : 0) > 4;
  }

  @HostListener('document:mouseup', ['$event']) onDocumentClick(event: any) {
    this.resizing = false;
  }

  private resetComponent(): void {
    this.isShown = false;
    this.seeContent = false;
    this.contentIsShown = false;
    this.contentSanitize = undefined;
    this.showString = 'f.concealable-panel.show-more';
  }
}
